// extracted by mini-css-extract-plugin
module.exports = {"userLinkContainer":"AccountIcon_userLinkContainer__AJS0I","accessibilityButton":"AccountIcon_accessibilityButton__5IUu_"};